import { render, staticRenderFns } from "./DoughnutChartExpense.vue?vue&type=template&id=3a7b1484&scoped=true&"
import script from "./DoughnutChartExpense.vue?vue&type=script&lang=js&"
export * from "./DoughnutChartExpense.vue?vue&type=script&lang=js&"
import style0 from "./DoughnutChartExpense.vue?vue&type=style&index=0&id=3a7b1484&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7b1484",
  null
  
)

export default component.exports